/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router";

import PropTypes from "prop-types";
import { defaultCurrency } from "../../../shared/constants/currency";
import { getBackgroundImage } from "../../../shared/utilities/common";
import DiscountTag from "../../DiscountTag/DiscountTag";

import styles from "./MediumProduct.module.css";

const MediumProduct = props => {
  const {
    primaryImage,
    secondaryImage,
    price,
    strikePrice,
    title,
    onAdd,
    isLimited,
    icon,
    onClick,
    className,
    doughProOverlay,
    calories,
    currency,
    isSingle,
    oos,
    productSlug,
    discountPercent,
    // eslint-disable-next-line no-unused-vars
    description,
    // eslint-disable-next-line no-unused-vars
    alternate
  } = props;
  const anchorTagRef = useRef(null);

  useEffect(() => {
    const anchor = anchorTagRef.current;
    if (!anchor) return;

    const handleClick = e => {
      e.preventDefault();
    };

    anchor.addEventListener("click", handleClick);

    // eslint-disable-next-line
    return () => {
      anchor.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <a
      ref={anchorTagRef}
      href={`/products/${productSlug}`}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className="group"
      aria-label={`View ${title} product details`}
    >
      <div
        data-ddog-id="medium_product"
        className={`
          ${styles.mediumWrapper}
          ${className}
          flex flex-col w-full
          `}
      >
        {/* Image container with absolute positioned button - 1:1 aspect ratio */}
        <div
          className="relative mx-auto"
          style={{ width: "238px", height: "238px" }}
        >
          {secondaryImage ? (
            <img
              onClick={onClick}
              src={`${getBackgroundImage(secondaryImage)}`}
              alt=""
              aria-hidden="true"
              className="absolute right-2 top-2 object-contain cursor-pointer"
              style={{ width: "60px", height: "60px", zIndex: 100 }}
            />
          ) : null}
          {isLimited ? (
            <div
              className="bg-[#983992] absolute right-2 top-2 text-center rounded-full text-white z-10 flex items-center justify-center p-1"
              style={{
                width: "52px",
                height: "52px",
                fontSize: "8px",
                lineHeight: "9px"
              }}
            >
              <p className="capitalize m-0">LIMITED TIME ONLY</p>
            </div>
          ) : null}

          <div
            onClick={onClick}
            className="w-full h-full flex items-center justify-center cursor-pointer"
          >
            <img
              alt={`${title} product`}
              src={primaryImage}
              className="product-main-image group-hover:scale-110 transition-all duration-300"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                width: "auto",
                height: "auto",
                objectFit: "contain"
              }}
            />
          </div>

          {oos === 1 && isSingle ? null : (
            <div
              data-ddog-id="medium_product_add_one"
              role="button"
              tabIndex={0}
              aria-label={
                isSingle ? `Add ${title} to cart` : `View ${title} details`
              }
              onClick={isSingle ? onAdd : onClick}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  if (isSingle) {
                    onAdd();
                  } else {
                    onClick();
                  }
                }
              }}
              className="absolute dark:bg-button bg-dark flex items-center justify-center z-20 cursor-pointer"
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "50%",
                bottom: "8px",
                right: "8px"
              }}
            >
              <img
                alt=""
                src={icon}
                aria-hidden="true"
                style={{ width: "24px", height: "24px" }}
              />
            </div>
          )}
        </div>

        {/* Product details centered below image */}
        <div
          onClick={onClick}
          className="font-montserratBold font-bold text-center px-2 py-3 flex flex-col items-center cursor-pointer"
        >
          {discountPercent > 0 ? (
            <DiscountTag discountPercent={discountPercent} className="mb-1" />
          ) : null}

          <h4 className="text-[16px] mb-1 leading-tight">
            {title}
            {calories ? ` ${calories}` : ""}
          </h4>

          {doughProOverlay ? (
            <h5 className="text-xs mb-1">CookieMagic Member Exclusive</h5>
          ) : null}

          {price ? (
            strikePrice ? (
              <span className="text-[16px] leading-[20px] tracking-[-0.1px] text-[#983992]">
                <strike>{`${currency.symbol}${strikePrice}  `}</strike>
                &nbsp;
                {`${currency.symbol}${price}`}
              </span>
            ) : (
              <span className="text-[16px] leading-[20px] tracking-[-0.1px] text-[#983992]">{`${currency.symbol}${price}`}</span>
            )
          ) : null}
        </div>
      </div>
    </a>
  );
};

MediumProduct.propTypes = {
  primaryImage: PropTypes.node.isRequired,
  secondaryImage: PropTypes.node,
  price: PropTypes.number,
  strikePrice: PropTypes.number,
  title: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  isLimited: PropTypes.bool,
  description: PropTypes.string.isRequired,
  alternate: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  className: PropTypes.string.isRequired,
  doughProOverlay: PropTypes.bool,
  calories: PropTypes.string,
  currency: PropTypes.shape({
    symbol: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string
  }),
  isSingle: PropTypes.bool.isRequired,
  oos: PropTypes.number,
  productSlug: PropTypes.string,
  discountPercent: PropTypes.number
};

MediumProduct.defaultProps = {
  secondaryImage: null,
  isLimited: false,
  alternate: false,
  price: null,
  strikePrice: null,
  doughProOverlay: false,
  calories: null,
  currency: defaultCurrency,
  oos: null,
  productSlug: "",
  discountPercent: 0
};

export default withRouter(MediumProduct);
